import React, { useContext, useState } from "react";
import {
  CustomModal,
  PlanCards,
  LoaderWrapper,
} from "../../../../../components";
import { get, isEmpty } from "lodash";
import {
  getAdvancedPathWithParam,
  MANAGE_TRANSFER_ROUTES,
  MANAGE_CENSUS_ROUTES,
} from "../../../../../utils";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
} from "../../../../../abstracts";
import ManageDistributionLayout from "../../../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { useHistory } from "react-router-dom";
import InvestmentDetails from "../TransferRequest/InvestmentDetail/InvestmentDetails";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import {
  appLayoutStore,
  globalToastInfo,
  manageDistributionStore,
  saveTransferRequest,
  setManageDistributionToastInfo,
} from "../../../../../contexts";
import { getTransferDetails } from "../../../../../services";

const TransferSummaryContainer = (props) => {
  const history = useHistory();
  const { flow, censusId } = useRouterParams();
  const { state, dispatch } = useContext(manageDistributionStore);
  const { dispatch: globalDispatch } = useContext(appLayoutStore);
  const transferDetails = get(state, "api.data.transferDetails", []);
  const currentHolding = get(state, "currentHoldings", []);
  const [employeeImage, setEmployeeImage] = useState("");
  const [sourceData, setSourceData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalData, setModalData] = useState({
    header: "",
    content: "",
    btnTextPrimary: "Yes",
    btnTextSecondary: "No",
    icon: "",
    color: "",
    btnColor: "",
  });

  const { response: transferApiData, loading: loading } = useRequest({
    method: getTransferDetails,
    payload: censusId,
    defaultResponse: [],
  });

  useDeepEffect(() => {
    setSourceData(
      !isEmpty(transferDetails)
        ? transferDetails.transferSourceDetails.map((item) => {
            return { ...item, show: false };
          })
        : !isEmpty(transferApiData)
        ? transferApiData.transferDetails.transferSourceDetails.map((item) => {
            return { ...item, show: false };
          })
        : []
    );
  }, [transferApiData]);

  const hideCard = (idx) => {
    setSourceData(
      sourceData.map((item, i) => {
        if (i === idx) {
          return { ...item, show: !item.show };
        }
        return item;
      })
    );
  };

  const buttons = [
    {
      label: "Back",
      variant: "secondary",
      type: "button",
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_TRANSFER_ROUTES.TRANSFER_REQUEST,
            pathParam: [flow, censusId],
          })
        ),
    },
    {
      label: "Submit",
      variant: "primary",
      type: "submit",
      onClick: () => onSubmit(),
    },
  ];

  const onCancelClick = () => {
    let data = {
      ...transferDetails,
      transferStatus: 2,
      isFutureContribution: false,
    };
    saveData(data);
  };

  const onSubmitClick = () => {
    let data = {
      ...transferDetails,
      transferStatus: 2,
      isFutureContribution: true,
    };
    saveData(data);
  };

  const saveData = (data) => {
    setIsLoading(true);
    setIsModalOpen(!isModalOpen);
    saveTransferRequest(data, false, dispatch)
      .then((res) => {
        setIsLoading(false);
        if (res.isSuccessfull) {
          globalDispatch(
            globalToastInfo({
              showToast: true,
              toastMessage: "Request saved successfully",
            })
          );
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
              pathParam: [flow, censusId],
            })
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        //error
      });
  };

  const onSubmit = () => {
    setModalData({
      header: "Update Contributions",
      content: "Do you want to save this election for future contributions?",
      btnTextPrimary: "Yes",
      btnTextSecondary: "No",
      icon: faInfoCircle,
      color: "#307BF6",
      btnColor: "#307BF6",
    });
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div>
      <LoaderWrapper isLoading={isLoading}>
        <ManageDistributionLayout
          buttons={buttons}
          layoutHeader="Transfer summary"
          employeeImage={employeeImage}
        >
          <div className="transfer-container">
            <p className="ft-16 fw-500">Plan Details</p>
            <PlanCards
              plans={
                !isEmpty(transferDetails)
                  ? [transferDetails]
                  : [transferApiData.transferDetails]
              }
              isTransfer={true}
              isViewOnly={true}
            />
            <p className="ft-16 fw-500">Sources</p>
            <InvestmentDetails
              data={sourceData}
              currentHolding={currentHolding}
              hideCard={hideCard}
              isViewOnly={true}
            />
          </div>
        </ManageDistributionLayout>
        <CustomModal
          color={modalData.color}
          icon={modalData.icon}
          header={modalData.header}
          content={modalData.content}
          isModalOpen={isModalOpen}
          onCancelClick={onCancelClick}
          onSubmitClick={onSubmitClick}
          btnTextPrimary={modalData.btnTextPrimary}
          btnTextSecondary={modalData.btnTextSecondary}
          btnColor={modalData.btnColor}
        />
      </LoaderWrapper>
    </div>
  );
};
export default TransferSummaryContainer;
